import { render, staticRenderFns } from "./Historiana.vue?vue&type=template&id=0bac9f42&"
import script from "./Historiana.vue?vue&type=script&lang=js&"
export * from "./Historiana.vue?vue&type=script&lang=js&"
import style0 from "./Historiana.vue?vue&type=style&index=0&id=0bac9f42&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports